import MFounder from "assets/images/jpgs/M-Founder.jpg";
import FFounder from "assets/images/jpgs/F-Founder.jpg";
import FoundersCard from "./components/FoundersCard";
import { useState } from "react";
import FounderModal from "layout/modal/FounderModal";
import Founder2Modal from "layout/modal/Founder2Modal";
import styled from "styled-components";
import MotherChildSingle from "assets/images/jpgs/MotherChildSingle.jpg";

const FoundersMeet = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };
  const openModal2 = () => {
    setModalOpen2(true);
  };

  const closeModal2 = () => {
    setModalOpen2(false);
  };

  return (
    <Wrapper>
      <div className="relative px-16 max-[450px]:px-8 py-16 flex flex-col justify-center items-start gap-6">
        <FounderModal isOpen={modalOpen} onClose={closeModal} />
        <Founder2Modal isOpen={modalOpen2} onClose2={closeModal2} />
        <div className="w-full border-b border-[#9E9696] p-2">
          <p className="uppercase leading-[35px] text-[30px] font-bold">
            Meet the founders
          </p>
        </div>
        <div className="w-full mt-4 p-8 flex flex-wrap justify-around items-center gap-10">
          <FoundersCard
            differ
            openModal={openModal}
            imageUrl={MFounder}
            name="Ife Oyedele"
            position="Co-Founder"
            link="https://www.linkedin.com/in/ife-oyedele-ii/"
          />
          <FoundersCard
            openModal2={openModal2}
            imageUrl={FFounder}
            name="Chinenye Etoniru"
            position="Co-Founder"
            link="https://www.linkedin.com/in/chinenye-etoniru/"
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default FoundersMeet;

const Wrapper = styled.div`
  background-position: center;
  /* background-image: url(${MotherChildSingle}); */
  background: rgba(250, 250, 250, 0.85);
  background-repeat: no-repeat;
  background-size: cover;
`;
